import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatQuery, getDealerLotSingle } from '@/actions/remoteActions';
import { dealerLotDuck, recentSearchDuck } from '@/ducks';
import { PersonalizationEngineModule } from '@/modules';

export const getDealerLotData = async ({
    recentSearchQuery,
    topRankedVehicle,
    makeCode,
    searchZip,
    dealerId,
    mockQueries,
    dispatch,
}) => {
    let dealerLotQuery = { zip: searchZip };

    if (recentSearchQuery) {
        dealerLotQuery = formatQuery(recentSearchQuery, searchZip);
    } else if (topRankedVehicle?.make) {
        const topRankedVehicleQuery = {
            makeCode: topRankedVehicle?.make?.code,
            modelCode: topRankedVehicle?.model?.code,
            bodyStyleCode: topRankedVehicle?.bodyStyle?.code,
        };
        dealerLotQuery = formatQuery(topRankedVehicleQuery, searchZip);
    } else if (makeCode) { // Single Dealer is only on Make & HP -- otherwise would check for general page context
        dealerLotQuery.makeCode = makeCode;
    }

    if (dealerId) {
        dealerLotQuery.dealerId = dealerId;
        dealerLotQuery.listingType = 'NEW';
    }

    dispatch(getDealerLotSingle(dealerLotQuery, mockQueries));
};

export default async function useELotCheck({
    searchZip,
    mockQueries,
    // make page
    makeCode,
    dealerId,
}) {
    const dispatch = useDispatch();

    const fetchedDealerLot = useSelector(dealerLotDuck.selectors.fetchedDealerLot);
    const recentSearchQuery = useSelector(recentSearchDuck.selectors.getRecentSearchQuery);
    const fetchedRecentSearchLocalStorage = useSelector(recentSearchDuck.selectors.fetchedRecentSearchLocalStorage);
    const { topRankedVehicle } = useSelector(PersonalizationEngineModule.duck.selectors.selectPreferences);

    useEffect(() => {
        if (fetchedRecentSearchLocalStorage && !fetchedDealerLot) {
            getDealerLotData({
                searchZip,
                mockQueries,
                makeCode,
                dealerId,
                recentSearchQuery,
                topRankedVehicle,
                dispatch,
            });
        }
    }, [fetchedDealerLot, fetchedRecentSearchLocalStorage]);
}
